export enum StatementType {
  Daily = 1,
  Monthly = 2,
}

export interface StatementFile {
  filename: string
  url: string
}
